<style lang="scss" scoped>
.form-control {
  height: 40px;
}
</style>

<template>
  <div>
    <label class="form-label">{{ label || "Resultate" }}</label>
    <input
      class="form-control"
      type="text"
      :min="0"
      :value="realValue"
      @input="emitFilter"
    />
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: null,
    label: null,
    id: null,
    attributes: null,
    name: {
      required: false,
      default: 'where'
    }
  },
  computed: {
    realValue() {
      if (!this.value) {
        return null;
      }

      return this.value[this.attributes];
    }
  },
  methods: {
    emitFilter(event) {
      if (event.target.value) {
        this.$emit('filter-change', {
          id: this.id,
          name: this.name,
          attributes: {
            [this.attributes]: event.target.value,
          }
        });
      } else {
        this.$emit('filter-change', {name: this.name, id: this.id});
      }
    }
  }
};
</script>
